import { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { addDays, format, isEqual, parseISO, subMonths } from "date-fns";
import { useFormik } from "formik";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  ListItemText,
  FormControl,
  TextField,
  Select,
  Checkbox,
  InputLabel,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TrainingPlansContext from "../../../context/FormacionDesarollo/TrainingPlansContext";
import { Form } from "semantic-ui-react";
import DateRangeFieldSV from "../../MyMood/Fields/DateRangeFieldSV";
import AdminColaboradoresTrainingPlan from "./AdminColaboradoresTrainingPlan";
import { ErrorAlert } from "../../../alerts/errorAlert";
import Add from "../../../assets/svg/addPrestacion.svg";
import "../css/ModalCreateTrainingPlan.css";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  GET_ALL_PROJECT,
  GET_ALL_TRAININGPLANS,
  GET_AVAILABLE_COURSES2,
  GET_TRAININGPLAN_BY_ID,
  GET_USERS_BY_PROJECT,
  UPDATE_TRAININGPLAN,
} from "../../../Querys/querys";
import {clearTrainingPlan, createUserTPModal } from "../../../context/FormacionDesarollo/TrainingPlansActions";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
//import moment from "moment";
export const UpdateTrainingPlan = () => {
  const { state, dispatch } = useContext(TrainingPlansContext);
  const [initialValuesForm, setInitialValuesForm] = useState({
    title: "",
    description: "",
    area: "",
    cursos: "",
  });
  const [stateCalendario, setStateCalendario] = useState([
    {
      startDate: subMonths(new Date(), 0),
      endDate: addDays(new Date(), 0),
      key: "selection",
    },
  ]);

  const [startDate, setStartDate] = useState(
    subMonths(new Date(), 0).toString()
  );
  const [endDate, setEndDate] = useState(addDays(new Date(), 0).toString());

  const [selectedAllProjects, setSelectedAllProjects] = useState<String[]>([]);
  const [selectedAllCourses, setSelectedAllCourses] = useState<Array<any>>([]);
  const [usersByCampusProject, setUsersByCampusProject] = useState<Array<any>>(
    []
  );

  const [counterTxt, setCounterTxt] = useState(0);
  const [colaboradoresBD, setColaboradoresBD] = useState<Array<any>>([]);
  const [projects, setProjects] = useState<Array<any>>([]);
  const [cursos, setCursos] = useState<Array<any>>([]);
  const [disableBtn, setDisableBtn] = useState(false);
  const { data: resultProject } = useQuery(GET_ALL_PROJECT);
  const allProject = resultProject?.GET_ALL_PROJECT;
  const [getUserByProject] = useLazyQuery(GET_USERS_BY_PROJECT);

  const { data: availableCourses } = useQuery(GET_AVAILABLE_COURSES2, {
    fetchPolicy: "no-cache",
  });
  const allAvailableCourses = availableCourses?.GET_AVAILABLE_COURSES;
  console.log("ALLCuros", allAvailableCourses);
  const [selectedUser, setSelectedUser] = useState<Array<any>>([]);

  const { data: trainingPlanID, loading } = useQuery(GET_TRAININGPLAN_BY_ID, {
    variables: {
      getTrainingplanByIdId: state._id,
    },
    fetchPolicy: "no-cache",
  });

  const [updateTrainingPlan] = useMutation(UPDATE_TRAININGPLAN, {
    refetchQueries: [{ query: GET_ALL_TRAININGPLANS }],
  });

  useEffect(() => {
    if (trainingPlanID && trainingPlanID?.GET_TRAININGPLAN_BY_ID) {
      //console.log("data", trainingPlanID?.GET_TRAININGPLAN_BY_ID);
      const trainingPLData = trainingPlanID?.GET_TRAININGPLAN_BY_ID;
      setCounterTxt(trainingPLData?.descriptionTrainingPlan.length);
      const iID = trainingPLData?.startTrainingPlan?.slice(0, 10);
      const iFD = trainingPLData?.endTrainingPlan?.slice(0, 10);
      setStartDate(iID);
      setEndDate(iFD);
      const [year, month, day] = iID.split("-").map(Number);
      const [yearF, monthF, dayF] = iFD.split("-").map(Number);
      setStateCalendario([
        {
          startDate: subMonths(new Date(year, month - 1, day), 0),
          endDate: addDays(new Date(yearF, monthF - 1, dayF), 0),
          key: "selection",
        },
      ]);
      setSelectedAllCourses(trainingPLData?.cursos);
      setColaboradoresBD(trainingPLData?.usuarios);
      let areass: any = [];
      trainingPLData?.areas.map((item: any) => {
        areass.push(item.area);
      });
      setSelectedAllProjects(areass);
      setInitialValuesForm({
        title: trainingPLData?.nameTrainingPlan,
        description: trainingPLData?.descriptionTrainingPlan,
        area: areass,
        cursos: trainingPLData?.cursos,
      });
    }
  }, [trainingPlanID]);

  //Reinicia el formik para tener los valores del id
  useEffect(() => {
    formik.resetForm({ values: initialValuesForm });
  }, [initialValuesForm]);

  const counterCaracter = (e: any) => {
    setCounterTxt(e.length);
  };

  const onChangeProject = (e: any) => {
    if (e.target.value.indexOf("Todas") > -1) {
      if (projects.length === selectedAllProjects.length) {
        setSelectedAllProjects([]);
        formik.setFieldValue("area", []);
      } else {
        let filtered = projects.map((item: any) => item.proyectNameAndClient);
        setSelectedAllProjects(filtered);
        formik.setFieldValue("area", [filtered]);
      }
    } else {
      setSelectedAllProjects(e.target.value);
    }
  };

  const onChangeCursos = (e: any) => {
    const { value } = e.target;
    if (e.target.value.indexOf("Todos") > -1) {
      if (cursos.length === selectedAllCourses.length) {
        setSelectedAllCourses([]);
        formik.setFieldValue("cursos", []);
      } else {
        let filtered = cursos.map((item: any) => item);
        setSelectedAllCourses(filtered);
        formik.setFieldValue("cursos", filtered);
      }
    } else {
      const newSelected = value.filter((v: any) => v !== "Todos");
      //console.log("ADWDE", newSelected);
      //ACONtar los elementos
      const countMap = newSelected.reduce((acc: any, item: any) => {
        acc[item.id] = (acc[item.id] || 0) + 1;
        return acc;
      }, {} as Record<number, number>);

      // Filtrar la lista para dejar solo los elementos que aparecen una vez
      const unique = newSelected.filter((item: any) => countMap[item.id] === 1);
      formik.setFieldValue("cursos", unique);
      setSelectedAllCourses(unique);
    }
  };

  const handleAdminColaborador = async () => {
    //console.log("Area seleccionada: ", selectedAllProjects);
    if (selectedAllProjects.length === 0) {
      ErrorAlert({ text: "Seleccione el Area" });
      return;
    } else {
      setUsersByCampusProject([]);
      const proyectsName = selectedAllProjects.map((name: any) => {
        const nameSplit = name.split("/");
        return nameSplit[0];
      });
      //console.log("array de proyectos: ", proyectsName);
      let { data } = await getUserByProject({
        variables: {
          input: {
            projects: proyectsName,
          },
        },
      });
      //console.log("valor de data: ", data);
      if (data.GET_USERS_BY_PROJECT.length > 0) {
        setUsersByCampusProject(data.GET_USERS_BY_PROJECT);
        createUserTPModal(state._id, true, dispatch);
      } else {
        ErrorAlert({
          text: "No hay colaboradores con los valores seleccionados",
        });
      }
    }
  };

  const closeModalCreateTraingPlan = () => {
    setCounterTxt(0);
    setSelectedAllCourses([]);
    setSelectedAllProjects([]);
    setSelectedUser([]);
    formik.resetForm();
    clearTrainingPlan(false, dispatch);
  };

  useEffect(() => {
    if (allProject) {
      setProjects(allProject);
    }
    if (allAvailableCourses) {
      setCursos(allAvailableCourses);
    }
  }, [allAvailableCourses, allProject]);

  const validationSchema = () => {
    return {
      title: Yup.string().trim().required(
        "El nombre del plan de capacitación es requerido"
      ),
      area: Yup.array()
        .required("Obligatorio")
        .test(
          "area",
          "Es necesario seleccionar al menos una área o proyecto",
          function (value) {
            if (value === undefined || value.length === 0) {
              return false;
            } else {
              return true;
            }
          }
        ),
      cursos: Yup.array()
        .required("Obligatorio")
        .test(
          "cursos",
          "Es necesario seleccionar al menos un curso",
          function (value) {
            if (value === undefined || value.length === 0) {
              return false;
            } else {
              return true;
            }
          }
        ),
    };
  };

  const formik = useFormik({
    initialValues: initialValuesForm,
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formData, { resetForm }) => {
      if (selectedUser.length === 0) {
        const usersFormat = colaboradoresBD.map((us) => ({ id: us.idUsuario }));
        setSelectedUser(usersFormat);
      }

      if (selectedUser.length === 0 && colaboradoresBD.length === 0) {
        ErrorAlert({
          text: "Es necesario agregar usuarios al plan de capacitación",
        });
        return;
      }

      const updatedSelectedUser =
        selectedUser.length === 0
          ? colaboradoresBD.map((us) => ({ id: us.idUsuario }))
          : selectedUser.map((us) => ({ id: us.id }));
      const cursosFormat = selectedAllCourses.map((us) => ({
        id: parseInt(us.id),
        title: us.title,
      }));
      const initDate: any = format(stateCalendario[0].startDate, "yyyy-MM-dd");
      const endDate: any = format(stateCalendario[0].endDate, "yyyy-MM-dd");
      const dateEqual = isEqual(parseISO(initDate), parseISO(endDate));
      if (dateEqual) {
        ErrorAlert({ text: "Necesita seleccionar un rango de fechas" });
        return;
      }
      const updateData = {
        id: state._id,
        title: formData.title.trim(),
        description: formData.description.trim(),
        dateInit: initDate,
        dateEnd: endDate,
        area: selectedAllProjects,
        cursos: cursosFormat,
        usuarios: updatedSelectedUser,
      };
      //console.log("Datasos", updateData);
      try {
        setDisableBtn(true);
        const data = await updateTrainingPlan({
          variables: {
            input: updateData,
          },
        });
        SuccessfulAlert({
          text: "Actualización realizada con éxito",
        });
        closeModalCreateTraingPlan();
        setDisableBtn(false);
      } catch (error) {
        ErrorAlert({
          text: "Ocurrió un error al actualizar el plan de capacitación",
        });
        setDisableBtn(false);
      }
    },
  });
  // console.log('Initial values', initialValuesForm)
  //  console.log('Cursos', selectedAllCourses)
  // // console.log("AREa", selectedAllProjects)
  // console.log("UusaruisBD", colaboradoresBD)
  // console.log("SELECIONADOS", selectedUser)
  // console.log("FECHAS", stateCalendario)
  // console.log("FechasI", startDate)
  // console.log("Fecha2", endDate)
  // console.log(subMonths(new  Date(parseInt(moment(startDate).format('YYYY')), parseInt(moment(startDate).format('MM')), parseInt(moment(startDate).format('DD'))), 1))
  // console.log(" FEHAS",new Date(2024,7,20).toLocaleDateString())
  return (
    <>
      {loading === true ? (
        <></>
      ) : (
        <>
          <Dialog
            open={state.updateModalTrainingPlan}
            aria-labelledby="form-dialog-title"
            className="dialogTrainingPlan"
            fullWidth={true}
          >
            <IconButton
              aria-label="close"
              onClick={() => {
                clearTrainingPlan(false, dispatch);
              }}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <Form onSubmit={formik.handleSubmit}>
                <DialogTitle className="titleCreateTrainingPlan">
                  <span className="titleCreateTrainingPlan">
                    Actualizar Plan de Capacitación
                  </span>
                </DialogTitle>
                <DialogContent className="nameTrainingPlan">
                  <TextField
                    label="Nombre del plan de capacitación *"
                    name="title"
                    inputProps={{ maxLength: 50 }}
                    variant="outlined"
                    className="nameTrainingPlan"
                    size="small"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onKeyPress={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    error={formik.touched.title && Boolean(formik.errors.title)}
                    helperText={formik.touched.title && formik.errors.title}
                  />
                </DialogContent>
                <DialogContent>
                  <DateRangeFieldSV
                    setDate={setStateCalendario}
                    containerClass={"dateBorder"}
                    daySelected1={startDate}
                    daySelected2={endDate}
                    nameLabel={"Periodo"}
                  />
                </DialogContent>
                <DialogContent className="twoSelect">
                  <FormControl
                    className="selectCourses"
                    size="small"
                    variant="outlined"
                    error={
                      formik.touched.cursos && Boolean(formik.errors.cursos)
                    }
                  >
                    <InputLabel
                      id="label-cursos"
                      style={{
                        backgroundColor: "#FFFFFF",
                        // width: "124px",
                      }}
                    >
                      Seleccionar Cursos *
                    </InputLabel>
                    <Select
                      style={{
                        fontFamily: "Roboto",
                        fontStyle: "italic",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        // width: "212px",
                        // height: "40px",
                      }}
                      value={selectedAllCourses}
                      onChange={(e) => {
                        formik.handleChange(e);
                        onChangeCursos(e);
                      }}
                      labelId="label-cursos"
                      id="cursos"
                      name="cursos"
                      multiple
                      renderValue={(selected: any) =>
                        selected.map((x: any) => x.title)?.join(",")
                      }
                      error={
                        formik.touched.cursos && Boolean(formik.errors.cursos)
                      }
                    >
                      <MenuItem key={0} value={"Todos"}>
                        <Checkbox
                          checked={selectedAllCourses.length === cursos.length}
                          style={{ color: "#FABB00" }}
                        />
                        <ListItemText primary={"Todos"} />
                      </MenuItem>
                      {cursos.map((curso: any) => (
                        <MenuItem key={curso.id} value={curso}>
                          <Checkbox
                            checked={
                              selectedAllCourses.findIndex(
                                (x: any) => x.id === curso.id
                              ) > -1
                            }
                            style={{ color: "#FABB00" }}
                          />
                          <ListItemText primary={curso.title} />
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText style={{ color: "red", marginLeft: "0px" }}>
                      {formik.touched.cursos && formik.errors.cursos}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    size="small"
                    variant="outlined"
                    className="selectArea"
                    error={formik.touched.area && Boolean(formik.errors.area)}
                  >
                    <InputLabel
                      id="label-Area"
                      style={{ backgroundColor: "#FFFFFF", zIndex: 0 }}
                    >
                      &Aacute;rea o Proyecto*
                    </InputLabel>
                    <Select
                      style={{
                        fontFamily: "Roboto",
                        fontStyle: "italic",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                      }}
                      value={selectedAllProjects}
                      onChange={(e) => {
                        formik.handleChange(e);
                        onChangeProject(e);
                      }}
                      labelId="label-Area"
                      id="area"
                      name="area"
                      multiple
                      label="Área o Proyecto"
                      renderValue={(selected: any) => selected.join(",")}
                      error={formik.touched.area && Boolean(formik.errors.area)}
                    >
                      <MenuItem key={0} value={"Todas"}>
                        <Checkbox
                          checked={
                            selectedAllProjects.length === projects.length
                          }
                          style={{
                            color: "#FABB00",
                          }}
                        />
                        <ListItemText primary={"Todas"} />
                      </MenuItem>
                      {projects.map((project: any) => (
                        <MenuItem
                          key={project.id}
                          value={project.proyectNameAndClient}
                        >
                          <Checkbox
                            checked={
                              selectedAllProjects.indexOf(
                                project.proyectNameAndClient
                              ) > -1
                            }
                            style={{
                              color: "#FABB00",
                            }}
                          />
                          <ListItemText
                            primary={project.proyectNameAndClient}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      style={{
                        color: "red",
                        marginLeft: "0px",
                      }}
                    >
                      {formik.touched.area && formik.errors.area}
                    </FormHelperText>
                  </FormControl>
                </DialogContent>
                <DialogContent className="oneComponent">
                  <button
                    className="btnAdminColaboradorTrainingPlan"
                    type="button"
                    onClick={() => handleAdminColaborador()}
                  >{`Administrar colaboradores(${
                    selectedUser.length > 0
                      ? selectedUser.length
                      : colaboradoresBD.length
                  })`}</button>
                </DialogContent>
                <DialogContent className="inputDescription">
                  <TextField
                    id="outlined-multiline-static"
                    label="Descripción del plan de capacitación"
                    multiline
                    name="description"
                    className="inputDescription"
                    rows={4}
                    variant="outlined"
                    inputProps={{ maxLength: 300 }}
                    value={formik.values.description}
                    onChange={(e: any) => {
                      formik.handleChange(e);
                      counterCaracter(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    InputLabelProps={{
                      style: { zIndex: 0 },
                    }}
                    onKeyPress={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    error={
                      formik.touched.description &&
                      Boolean(formik.errors.description)
                    }
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                  />
                  <div className="divCounterCaracter">
                    <label className="txtConterDesc">
                      {`${counterTxt}/300`}{" "}
                    </label>
                  </div>
                </DialogContent>
                <DialogContent className="twoBtnsTrainingPlan">
                  <div className="containerButtons">
                    <div className="containerCancelTrainingPlan">
                      <button
                        className="btnCancelarTrainingPlan"
                        type="button"
                        onClick={() => {
                          closeModalCreateTraingPlan();
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                    <div className="containerAddTrainingPlan">
                      <button
                        className="btnAddTrainingPlan"
                        type="submit"
                        disabled={disableBtn}
                      >
                        <div className="infoBtnAddTrainingPlan">
                          <div>
                            <img
                              src={Add}
                              alt="Actualizar Plan de Capacitación"
                            />
                          </div>
                          <div>
                            <span className="txtBtnAdd">
                              Actualizar plan de capacitaci&oacute;n
                            </span>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </DialogContent>
              </Form>
            </DialogContent>
          </Dialog>
          {usersByCampusProject.length > 0 ? (
            <AdminColaboradoresTrainingPlan
              users={usersByCampusProject}
              userSelect={selectedUser}
              setSelectedUser={setSelectedUser}
              colaboradoresBD={colaboradoresBD}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default UpdateTrainingPlan;
